import type { Id } from "@repo/convex/dataModel";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { TeamsConsultationDialog } from "./teams-consultation-dialog";
import { TeamsIcon } from "./teams-icon";

export function InviteViaTeamsButton({
  clarificationRequestId,
  disabled,
}: {
  clarificationRequestId: Id<"clarificationRequests">;
  disabled?: boolean;
}) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        size="xs"
        variant="outline"
        className="gap-1.5"
        disabled={disabled}
        onClick={() => setOpen(true)}
      >
        <TeamsIcon size={14} />
        Invite via Teams
      </Button>
      <TeamsConsultationDialog
        clarificationRequestId={clarificationRequestId}
        open={open}
        onOpenChange={setOpen}
      />
    </>
  );
}
